import styled from 'styled-components'

export const Container = styled.div``

export const SearchContainer = styled.div`
  max-width: 1280px;
  margin: auto;
`

export const LoadingContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Title = styled.h1`
  font-family: Circular-Std-bold;
  text-align: left;

  @media (max-width: 1320px) {
    margin-left: 20px;
  }
`

export const PanelContainer = styled.div`
  display: flex;
  gap: 1%;
`
